import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/AdminSettingSeminarRoom';

const GetSettingSeminarRoomReducer = handleActions({
    [Actions.getSettingSeminarRoomRequested]: (state) => ({
        ...state,
        isFetching: true,
        isCompleted: false,
    }),
    [Actions.getSettingSeminarRoomReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        data: action.payload,
    }),
    [Actions.getSettingSeminarRoomReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        errors: action.payload.errors,
    }),
    [Actions.getSettingSeminarRoomClear]: () => ({
        isCompleted: false,
        isSuccessful: false,
        data: [],
        errors: {},
    }),
}, {
    isFetching: false,
    isCompleted: false,
    data: [],
    errors: {},
});

const UpdateSettingSeminarRoomReducer = handleActions({
    [Actions.updateSettingSeminarRoomRequested]: (state) => ({
        ...state,
        isFetching: true,
        isCompleted: false,
    }),
    [Actions.updateSettingSeminarRoomReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        data: action.payload,
    }),
    [Actions.updateSettingSeminarRoomReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        errors: action.payload.errors,
    }),
    [Actions.updateSettingSeminarRoomClear]: () => ({
        isCompleted: false,
        isSuccessful: false,
        data: [],
        errors: {},
    }),
}, {
    isFetching: false,
    isCompleted: false,
    data: [],
    errors: {},
});

export default combineReducers({
    get: GetSettingSeminarRoomReducer,
    update: UpdateSettingSeminarRoomReducer,
});
